export const getGeolocation = async function () {
    return new Promise((resolve, reject) => {
        try {
            if (!navigator.geolocation) throw 'Geolocation is not supported by your browser';

            const options = {
                maximumAge: 30 * 60 * 1000, // mise en cache de 30min
                timeout: 10 * 1000, // timeout au bout de 10s
            };
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    resolve(position);
                },
                (error) => {
                    reject(error);
                },
                options,
            );
        } catch (e) {
            throw e;
        }
    });
};